import { writable } from 'svelte/store';

interface ThemeAssets {
    faviconHref: string;
    logoHref: string;
}

interface ThemeConfig extends ThemeAssets {
    [key: string]: any;
}

const defaultTheme: ThemeConfig = {
    faviconHref: '/favicon.ico',
    logoHref: '/src/lib/assets/logo/allibee.svg',
    fontLinks: [],
};

export const themeStore = writable<ThemeConfig>(defaultTheme);

const getThemeAssetHref = async (assetType: 'favicon' | 'logo', defaultPath: string, config: any): Promise<string> => {
    const assetName = config?.[assetType];

    if (!assetName) return defaultPath;

    try {
        const assets = assetType === 'favicon' ? import.meta.glob('$lib/assets/favicons/*') : import.meta.glob('$lib/assets/logo/*');

        const assetKey = Object.keys(assets).find(key => {
            const fileName = key.split('/').pop();
            return fileName === assetName;
        });

        if (assetKey) {
            const module: any = await assets[assetKey]();
            return module.default;
        }
    } catch (error) {
        console.error(`${assetType}을 찾을 수 없습니다: ${config[assetType]}`, error);
    }

    return defaultPath;
};

const getThemeAssets = async (config: any) => {
    const [faviconHref, logoHref] = await Promise.all([getThemeAssetHref('favicon', defaultTheme.faviconHref, config), getThemeAssetHref('logo', defaultTheme.logoHref, config)]);

    return { faviconHref, logoHref };
};

export const updateThemeConfig = async (themeConfigs: any) => {
    const assets = await getThemeAssets(themeConfigs);

    themeStore.update(state => ({
        ...state,
        ...themeConfigs,
        ...assets,
    }));
};

export const setThemeConfig = async (themeConfigs: any) => {
    const assets = await getThemeAssets(themeConfigs);

    themeStore.set({
        ...themeConfigs,
        ...assets,
    });
};

setThemeConfig(__CONTRACT_THEME_CONFIG__);
